import { render, staticRenderFns } from "./CollectReport.vue?vue&type=template&id=723fec04&scoped=true&"
import script from "./CollectReport.vue?vue&type=script&lang=js&"
export * from "./CollectReport.vue?vue&type=script&lang=js&"
import style0 from "./CollectReport.vue?vue&type=style&index=0&id=723fec04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723fec04",
  null
  
)

export default component.exports